import { atom } from "recoil";
import { sessionStorageEffect } from "../../utils/storage-effects";

export const debugState = atom({
  key: "global/debug",
  effects_UNSTABLE: [sessionStorageEffect("debugMode")],
  default: false,
});
